import { ROOT_FOLDER_ID } from '../../../constants/rootFolderId'
import { FolderPathBreadcrumbItem } from '../types/folderPathBreadcrumbItem'

export const getTargetedParentFolderIdFromFolderPath = (folderPath: FolderPathBreadcrumbItem[]) => {
  if (folderPath.length === 0) {
    return null
  }
  const targetedParentFolder = folderPath.at(-1)

  if (!targetedParentFolder || targetedParentFolder?.id === ROOT_FOLDER_ID) {
    return null
  }

  return targetedParentFolder.id
}
